import { useParams } from 'react-router-dom';

import { assertIsDefined } from '@/utils/assert';

import { useFilterContext } from '../components/FilterContext';

export const useOrganizationId = () => {
  const { organizationId: contextOrganizationId } = useFilterContext();
  const { organizationId: paramOrganizationId } = useParams();

  const organizationId = contextOrganizationId ?? paramOrganizationId;

  assertIsDefined(organizationId, 'organizationId');

  return organizationId;
};

export const useSetOrganizationId = () => {
  const { setOrganizationId } = useFilterContext();
  return setOrganizationId;
};
